import React from 'react';
// @ts-ignore
import { emojify } from 'react-emojione'; // TODO install react-emojione (?)

import { Icon, Paper } from '@material-ui/core';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { Button, Typography } from 'embeds/components';

import { styles } from './styles';

export interface EmptyStateComponentProps extends WithStyles<typeof styles> {
  buttonIcon?: string;
  buttonIconStyle?: string;
  buttonLabelStyle?: string;
  buttonText?: string;
  icon?: string;
  subtitle?: string;
  title?: string;
  children?: JSX.Element;
  onClickButton?: () => void;
  style?: Record<string, unknown>;
  className?: string;
}

class EmptyStateComponent extends React.Component<EmptyStateComponentProps> {
  static defaultProps = {
    buttonIconStyle: '',
    buttonLabelStyle: '',
  };

  renderButtonIcon() {
    const { buttonIcon, buttonIconStyle, classes } = this.props;

    if (buttonIcon && buttonIcon !== '') {
      return <Icon className={classnames(classes.icon, buttonIconStyle)}>{buttonIcon}</Icon>;
    }

    return false;
  }

  render() {
    const {
      buttonText,
      buttonLabelStyle,
      children,
      icon,
      onClickButton,
      style,
      subtitle,
      title,
      classes,
      className,
    } = this.props;
    const hasButton = buttonText && buttonText.length > 0;

    return (
      <Paper className={classnames(classes.card, className)} style={style}>
        <span style={{ fontSize: 48 }}>{icon ? emojify(`${icon}`, { output: 'unicode' }) : ' '}</span>
        <Typography color="primary" className={classes.title} component="div">
          {title}
        </Typography>
        <Typography color="primary" className={classes.subtitle} component="div">
          {subtitle}
        </Typography>
        {children}
        {hasButton && (
          <Button color="primary" variant="contained" rounded onClick={onClickButton}>
            {this.renderButtonIcon()}
            <span
              // @ts-ignore
              className={classnames(classes.label, buttonLabelStyle)}
            >
              {buttonText}
            </span>
          </Button>
        )}
      </Paper>
    );
  }
}

export const EmptyState = withStyles(styles)(EmptyStateComponent);
